import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import actions from './actions';
import selector from './selector';

import UploadedLayout from './layout';

const handleSearch = (keywords, dispatch) => {
    dispatch(actions.getAudiences(keywords));
};

const UploadedDashboard = ({
    dispatch,
    audienceSegments,
    totalSegmentCount,
    isModalOpen,
    ...props
}) => {
    useEffect(() => {
        dispatch(actions.init());
    }, [1]);

    const onChange = value => {
        handleSearch(value, dispatch);
    };

    return (
        <UploadedLayout
            audienceSegments={audienceSegments}
            onSearch={onChange}
            segmentCount={totalSegmentCount}
            activeAudience={props.params.audienceId}
            isModalOpen={isModalOpen}
            organizationId={props.organizationId}
        />
    );
};

export default connect(selector)(UploadedDashboard);
